const COUNTRY_COOKIE = "country_code";

/** Replace (or add) the leading /xx country segment in a path. */
export function swapCountryInPath(pathname: string, code: string): string {
  const stripped = (pathname || "/").replace(/^\/[a-zA-Z]{2}(\/|$)/, "/");
  const tail = stripped === "/" ? "" : stripped;
  return `/${code.toLowerCase()}${tail}`;
}

/** The 2-letter country segment of a path, lowercased, or undefined. */
export function countryFromPath(pathname: string): string | undefined {
  const m = (pathname || "").match(/^\/([a-zA-Z]{2})(\/|$)/);
  return m ? m[1].toLowerCase() : undefined;
}

/**
 * Persist the selected country in a cookie so the server (proxy.ts) can
 * redirect a country-less request straight to the user's country instead of a
 * hardcoded default. Non-httpOnly by design: it is not sensitive and is only a
 * routing hint. No-op on the server.
 */
export function setCountryCookie(code: string): void {
  if (typeof document === "undefined") return;
  document.cookie = `${COUNTRY_COOKIE}=${code.toLowerCase()}; path=/; max-age=${
    60 * 60 * 24 * 365
  }; samesite=lax`;
}

export function clearCountryCookie(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${COUNTRY_COOKIE}=; path=/; max-age=0; samesite=lax`;
}

export { COUNTRY_COOKIE };
